/**
 * Content Hero Banner 2 Component
 * Handles slide-in animations and interactivity for the content hero banner 2 section
 */

(function() {
  class ContentHeroBanner2 extends HTMLElement {
    constructor() {
      super();
      this.observer = null;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      // Check if animation is enabled via data attribute
      const textElement = this.querySelector('[data-animation-type="text"]');
      
      if (!textElement) return;

      // Trigger animation on page load or when element becomes visible
      if (this.isAnimationEnabled(textElement)) {
        this.observeElementVisibility(textElement);
      }
    }

    isAnimationEnabled(element) {
      // Check if the element has the animation class
      return element.classList.contains('content-hero-banner-2-animated');
    }

    observeElementVisibility(element) {
      // Use Intersection Observer to trigger animation when element enters viewport
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Remove inline animation style to allow CSS animation to run
            entry.target.style.animation = null;
            this.observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1, // Trigger when 10% of element is visible
        rootMargin: '50px' // Start animation slightly before element is fully visible
      });

      this.observer.observe(element);
    }

    disconnectedCallback() {
      // Cleanup observer to prevent memory leak
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }

  // Register the custom element
  customElements.define('content-hero-banner-2', ContentHeroBanner2);
})();
